export class SheetActivity{
  id: number = 0
  student_id: number = 0
  page: number = 0
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  base64Image: string | null = null

  constructor(sa: any){
    this.id = sa.id;
    this.student_id = sa.student_id;
    this.page = sa.page;
  }
}

export class StudentDetail{
  id: number = 0
  room_id: number = 0
  room_name: string = ""
  number: number = 0
  name: string = ""
  user_id: number = 0
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  isAbsent: boolean = false

  constructor(student_detail: any, sheet_activities: any[]){
    this.id = student_detail.id;
    this.room_id = student_detail.room_id;
    this.room_name = student_detail.room_name;
    this.number = student_detail.number;
    this.name = student_detail.name;
    this.user_id = student_detail.user_id;
    
    const sheetActivities = new Array<SheetActivity>();
    sheet_activities.filter((x: any) => x.student_id == this.user_id).forEach((x: any) => {
      sheetActivities.push(new SheetActivity(x));
    });
    
    this.sheetActivities = sheetActivities.sort((a: SheetActivity, b: SheetActivity) => a.page < b.page ? -1 : 1);
  }
}